import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, CardContent, CardActions } from '@material-ui/core';

/* const useStyles = makeStyles(theme => ({
    card: {
       //  height: 600,
        width: 400,
        maxWidth: 345,
    }
  })); */
const TaxePanel = props => {
    const { children } = props
    //const classes = useStyles();
    return (
        <Grid  item xs={12} md={6} lg={6} >
            <Card>
                <CardContent>
                    { children }
                </CardContent>
                <CardActions ></CardActions>
            </Card>
        </Grid>
    );
};

TaxePanel.propTypes = {
    children: PropTypes.node.isRequired,
};

export default TaxePanel;